import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Drawer, Grid, Typography } from '@material-ui/core/'
import { makeStyles } from '@material-ui/core/styles'
import { setChatNotification } from '../../../modules/chatCategory/actions'
import LikeMess from './components/LikeMess'
import ReviewMess from './components/ReviewMess'
import BeforeMess from './components/BeforeMess'
import AddStoryMess from './components/AddStoryMess'
import DeclineMeetMess from './components/DeclineMeetMess'
import DeclineChatMess from './components/DeclineChatMess'
import DeleteStoryMess from './components/DeleteStoryMess'
import DeleteOneStoryFromChat from './components/DeleteOneStoryFromChat'
import moment from 'moment'
import apiChat from '../../../api/chat'
import './index.scss'

const useStyles = makeStyles({
  paper: {
    height: 'calc(100% - 80px)',
    top: 80,
    zIndex: 999,
    boxShadow: 'none',
  },
})

const NotificationBar = ({ openSide, setOpenSide, notifications, getNotifications, open, readNotifacotions, setOpen }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { session } = useSelector(state => state)
  const classes = useStyles()
  const { user } = useSelector(({ session }) => session)
  const [seenId, setSeenId] = useState('')

  const goTo = path => history.push(path)

  const seenNotifications = () => {
    if (notifications?.length) {
      apiChat.seenNotifications(session?.user?.accessKey, notifications?.[0]?.uuid)
    }
  }

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setOpenSide(open)
  }

  useEffect(() => {
    if (openSide) {
      setSeenId(notifications?.[0]?.uuid)
    } else {
      getNotifications()
      setSeenId('')
    }
  }, [openSide])

  useEffect(() => {
    if (seenId) {
      seenNotifications()
    }
  }, [seenId])

  const list = anchor => (
    <div
      className='list'
      role='permanent'
    >
      <Grid className='notificateBox'>
        <Typography className='title'>Notifications</Typography>
        {notifications?.length ? (
          <Grid className='newNotBox'>
            <Typography className='newTitle'>New</Typography>
            {notifications?.map(i => (
              i?.type === 'like' ? (
                <LikeMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={+i?.time} name={i?.userName}
                  town={i?.userTown}
                  goTo={() => {
                    if (i?.story?.uuid) {
                      goTo(`/story/${i?.story?.uuid}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'meeting_review' ? (
                <ReviewMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={i?.meetingTime}
                  name={i?.userName}
                  goTo={() => {
                    goTo(`/chat/meeting-scheduled/${i?.thread}`)
                    setOpenSide(false)
                    dispatch(setChatNotification({ type: i?.type, name: i?.userName }))
                  }}
                />
              ) : i?.type === 'before_meeting' ? (
                <BeforeMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={i?.meetingTime}
                  goTo={() => {
                    goTo(`/chat/meeting-scheduled/${i?.thread}`)
                    setOpenSide(false)
                  }}
                />
              ) : i?.type === 'add_story_to_chat' ? (
                <AddStoryMess
                  key={i?.uuid}
                  img={i?.story?.image?.src}
                  time={i?.time}
                  name={i?.userName}
                  goTo={() => {
                    if (i?.thread) {
                      goTo(`/chat/meeting-scheduled/${i?.thread}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'meeting_refused' ? (
                <DeclineMeetMess
                  key={i?.uuid}
                  img={i?.story?.image?.src}
                  time={i?.time}
                  name={i?.userName}
                  goTo={() => {
                    if (i?.thread) {
                      goTo(`/chat/meeting-chat/${i?.thread}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'no_town' ? (
                <Grid className='townBox' key={i?.uuid}>
                  <Typography
                    className='userTown'
                    onClick={() => {
                      setOpen(true)
                      setOpenSide(false)
                    }}
                  >
                    Please fill in your location.
                  </Typography>
                  <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                </Grid>
              ) : i?.type === 'refuse_chat' ? (
                <DeclineChatMess
                  key={i?.uuid}
                  story={i?.story}
                  time={i?.time}
                  goTo={() => {
                    if (i?.story?.uuid) {
                      goTo(`/story/${i?.story?.uuid}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'delete_chat' ? (
                i?.deletedReason === 0 ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      Unfortunately, {i?.userName} removed  account so you can no longer see related chat.
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : i?.deletedReason === 3 ? (
                  i?.userName !== user?.user?.name ? (
                    <Grid className='townBox' key={i?.uuid}>
                      <Typography
                        className='userTown'
                      >
                        {i?.userName} wished to end this chat. Explore other stories and write yours. Remember: you matter no matter what.
                      </Typography>
                      <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                    </Grid>
                  ) : (
                    <Grid className='townBox' key={i?.uuid}>
                      <Typography
                        className='userTown'
                      >
                        You didn't want to continue chatting
                      </Typography>
                      <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                    </Grid>
                  )
                ) : i?.deletedReason === 1 ? (
                  i?.userName !== user?.user?.name ? (
                    <DeleteOneStoryFromChat
                      key={i?.uuid}
                      img={i?.storyImage?.src}
                      time={+i?.time}
                      name={i?.userName}
                      town={i?.userTown}
                    />
                  ) : null
                ) : i?.deletedReason === 4 ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      {i?.userName} story was deleted for inappropriate content. All related chats will be removed
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : i?.deletedReason === 5 ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      {i?.userName} has been deleted from tellMe for receiving too many negative feedbacks.
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : null
              ) : i?.type === 'delete_story_from_chat' ? (
                <DeleteStoryMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={i?.time}
                  name={i?.userName}
                  goTo={() => {
                    if (i?.thread) {
                      goTo(`/chat/meeting-scheduled/${i?.thread}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'own_story_deleted' ? (
                i?.byAdmin ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      Your story has been deleted for inappropriate content. All related chats will be removed.
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : (
                  i?.userUuid === user?.user?.uuid ? (
                    <DeleteOneStoryFromChat
                      key={i?.uuid}
                      img={i?.storyImage?.src}
                      time={+i?.time}
                      name={i?.userName}
                      town={i?.userTown}
                      avtor
                    />
                  ) : (
                    <DeleteOneStoryFromChat
                      key={i?.uuid}
                      img={i?.storyImage?.src}
                      time={+i?.time}
                      name={i?.userName}
                      town={i?.userTown}
                    />
                  )
                )
              ) : i?.type === 'anonymous_like' ? (
                <LikeMess
                  anonim
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={+i?.time} name={i?.userName}
                  town={i?.userTown}
                  goTo={() => {
                    if (i?.story?.uuid) {
                      goTo(`/story/${i?.story?.uuid}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : null
            ))}
          </Grid>
        ) : null}
        {readNotifacotions?.length ? (
          <Grid className='reedNotBox'>
            {readNotifacotions?.map(i => (
              i?.type === 'like' ? (
                <LikeMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={+i?.time} name={i?.userName}
                  town={i?.userTown}
                  goTo={() => {
                    if (i?.story?.uuid) {
                      goTo(`/story/${i?.story?.uuid}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'meeting_review' ? (
                <ReviewMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={i?.meetingTime}
                  name={i?.userName}
                  goTo={() => {
                    goTo(`/chat/meeting-scheduled/${i?.thread}`)
                    setOpenSide(false)
                    dispatch(setChatNotification({ type: i?.type, name: i?.userName }))
                  }}
                />
              ) : i?.type === 'before_meeting' ? (
                <BeforeMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={i?.meetingTime}
                  goTo={() => {
                    goTo(`/chat/meeting-scheduled/${i?.thread}`)
                    setOpenSide(false)
                  }}
                />
              ) : i?.type === 'add_story_to_chat' ? (
                <AddStoryMess
                  key={i?.uuid}
                  img={i?.story?.image?.src}
                  time={i?.time}
                  name={i?.userName}
                  goTo={() => {
                    if (i?.thread) {
                      goTo(`/chat/meeting-scheduled/${i?.thread}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'meeting_refused' ? (
                <DeclineMeetMess
                  key={i?.uuid}
                  img={i?.story?.image?.src}
                  time={i?.time}
                  name={i?.userName}
                  goTo={() => {
                    if (i?.thread) {
                      goTo(`/chat/meeting-chat/${i?.thread}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'no_town' ? (
                <Grid className='townBox' key={i?.uuid}>
                  <Typography
                    className='userTown'
                    onClick={() => {
                      setOpen(true)
                      setOpenSide(false)
                    }}
                  >
                    Please fill in your location.
                  </Typography>
                  <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                </Grid>
              ) : i?.type === 'refuse_chat' ? (
                <DeclineChatMess
                  key={i?.uuid}
                  story={i?.story}
                  time={i?.time}
                  goTo={() => {
                    if (i?.story?.uuid) {
                      goTo(`/story/${i?.story?.uuid}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'delete_chat' ? (
                i?.deletedReason === 1 ? (
                  i?.userName !== user?.user?.name ? (
                    <DeleteOneStoryFromChat
                      key={i?.uuid}
                      img={i?.storyImage?.src}
                      time={+i?.time}
                      name={i?.userName}
                      town={i?.userTown}
                    />
                  ) : null
                ) : i?.deletedReason === 0 ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      Unfortunately, {i?.userName} removed  account so you can no longer see related chat.
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : i?.deletedReason === 3 ? (
                  i?.userName !== user?.user?.name ? (
                    <Grid className='townBox' key={i?.uuid}>
                      <Typography
                        className='userTown'
                      >
                        {i?.userName} wished to end this chat. Explore other stories and write yours. Remember: you matter no matter what.
                      </Typography>
                      <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                    </Grid>
                  ) : (
                    <Grid className='townBox' key={i?.uuid}>
                      <Typography
                        className='userTown'
                      >
                        You didn't want to continue chatting
                      </Typography>
                      <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                    </Grid>
                  )
                ) : i?.deletedReason === 4 ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      {i?.userName} story was deleted for inappropriate content. All related chats will be removed
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : i?.deletedReason === 5 ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      {i?.userName} has been deleted from tellMe for receiving too many negative feedbacks.
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : null
              ) : i?.type === 'delete_story_from_chat' ? (
                <DeleteStoryMess
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={i?.time}
                  name={i?.userName}
                  goTo={() => {
                    if (i?.thread) {
                      goTo(`/chat/meeting-scheduled/${i?.thread}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : i?.type === 'own_story_deleted' ? (
                i?.byAdmin ? (
                  <Grid className='townBox' key={i?.uuid}>
                    <Typography
                      className='userTown'
                    >
                      Your story has been deleted for inappropriate content. All related chats will be removed.
                    </Typography>
                    <Typography className='time'>{moment(+i?.time)?.startOf('minutes')?.fromNow()}</Typography>
                  </Grid>
                ) : (
                  i?.userUuid === user?.user?.uuid ? (
                    <DeleteOneStoryFromChat
                      key={i?.uuid}
                      img={i?.storyImage?.src}
                      time={+i?.time}
                      name={i?.userName}
                      town={i?.userTown}
                      avtor
                    />
                  ) : (
                    <DeleteOneStoryFromChat
                      key={i?.uuid}
                      img={i?.storyImage?.src}
                      time={+i?.time}
                      name={i?.userName}
                      town={i?.userTown}
                    />
                  )
                )
              ) : i?.type === 'anonymous_like' ? (
                <LikeMess
                  anonim
                  key={i?.uuid}
                  img={i?.storyImage?.src}
                  time={+i?.time} name={i?.userName}
                  town={i?.userTown}
                  goTo={() => {
                    if (i?.story?.uuid) {
                      goTo(`/story/${i?.story?.uuid}`)
                      setOpenSide(false)
                    }
                  }}
                />
              ) : null
            ))}
          </Grid>
        ) : !notifications?.length && <Grid className='notNotificateText'>You currently don't have any notifications.</Grid>}
      </Grid>
    </div>
  )

  return (
    <div>
      <Drawer classes={{ paper: classes.paper }} anchor='right' open={openSide} onClose={toggleDrawer('right', false)}>
        {list('right')}
      </Drawer>
    </div>
  )
}

export default NotificationBar
